window.RecreationCentreLandingPageObject = function(opts) {
    var recreationCentreObj = {
        init: function() {
            this.bindEvents();
            this.onInit();

            return this;
        },

        bindEvents: function() {
            var self = this;

            $(document).ready(function() {
                self.onReady();
            });
        },

        //event handlers...
        onInit: function() {},
        onReady: function() {
            $('form').on('submit', function(e) {
                e.preventDefault();

                //fire off a tracking events
                if (typeof ga !== 'undefined') {
                    ga('send', 'event', 'Contact Form', 'Submit', 'Recreation Centre');
                }
                if (typeof goog_report_conversion === 'function') {
                    goog_report_conversion();
                }

                this.submit();
                return true;
            });

            this.initializeBonusForm();
            this.initializeRaffleForm();
        },
        onResize: function() {},
        onLoad: function() {},
        initializeBonusForm: function() {
            var formSelector = '#TotemForm_BonusForm';
            $(formSelector + ' input').prop('checked', false);
            this.bindRentFieldEvents(formSelector);
        },
        initializeRaffleForm: function() {
            var formSelector = '#TotemForm_RaffleForm';
            $(formSelector + ' input').prop('checked', false);
            $(formSelector + ' #IsInquiring input').attr('required', 'required');
            this.bindRentFieldEvents(formSelector);
            this.bindReferralFieldEvents(formSelector);
        },
        bindRentFieldEvents: function(formSelector) {
            var self = this;
            self.hideAndClearField(formSelector, '#WeeklyRentCost');
            $(formSelector + ' #IsRenting input').off('change');
            $(formSelector + ' #IsRenting input').on('change', function() {
                if ($(this).val() === '1') {
                    self.showAndRequireField(formSelector, '#WeeklyRentCost');
                } else {
                    self.hideAndClearField(formSelector, '#WeeklyRentCost');
                }
            });
        },
        bindReferralFieldEvents: function(formSelector) {
            var self = this;
            self.bindFriendFieldEvents(formSelector);
            self.hideAndClearField(formSelector, '#IsReferring');

            $(formSelector + ' #IsInquiring input').off('change');
            $(formSelector + ' #IsInquiring input').on('change', function() {
                if ($(this).val() === '0') {
                    self.showAndRequireField(formSelector, '#IsReferring');
                } else {
                    self.hideAndClearField(formSelector, '#IsReferring');
                    $(formSelector + ' #IsReferring #TotemForm_RaffleForm_IsReferring_0').click();
                    $(formSelector + ' #IsReferring input').prop('checked', false);
                }
                self.bindFriendFieldEvents(formSelector);
            });
        },
        bindFriendFieldEvents: function(formSelector) {
            var self = this;
            self.hideAndClearField(formSelector, '#FriendName');
            self.hideAndClearField(formSelector, '#FriendPhone');

            $(formSelector + ' #IsReferring input').off('change');
            $(formSelector + ' #IsReferring input').on('change', function() {
                if ($(this).val() === '1') {
                    self.showAndRequireField(formSelector, '#FriendName');
                    self.showAndRequireField(formSelector, '#FriendPhone');
                } else {
                    self.hideAndClearField(formSelector, '#FriendName');
                    self.hideAndClearField(formSelector, '#FriendPhone');
                }
            });
        },
        hideAndClearField: function(formSelector, fieldSelector) {
            $(formSelector + ' ' + fieldSelector).hide();
            $(formSelector + ' ' + fieldSelector + ' input').each(function() {
                if ($(this).attr('type') === 'radio') {
                    $(this).prop('checked', false);
                } else {
                    $(this).val('');
                }
            });
            $(formSelector + ' ' + fieldSelector + ' input').removeAttr('required');
        },

        showAndRequireField: function(formSelector, fieldSelector) {
            $(formSelector + ' ' + fieldSelector).show();
            $(formSelector + ' ' + fieldSelector + ' input').attr('required', 'required');
        }
    };

    if (opts) {
        return $.extend(recreationCentreObj, opts);
    } else {
        return recreationCentreObj;
    }
};
